import { Text } from "recharts";

const CustomizedYAxisTick = ({ x, y, payload }) => (
  <Text
    fontSize={14}
    fontStyle="normal"
    textTransform="capitalize"
    x={x}
    y={y}
    width={75}
    fill="#818181"
    textAnchor="end"
    verticalAnchor="middle"
    dx={-10}
  >
    {`${payload.value}°C`}
  </Text>
);

export default CustomizedYAxisTick;
